export const getDefaultSelectValue = (fieldValue, options) => {
  if (fieldValue === null || fieldValue === undefined || !options) {
    return null;
  }

  return options.find((option) => option.value === fieldValue);
};
